import { render, staticRenderFns } from "./statisticsFilter.vue?vue&type=template&id=88183ef0&scoped=true&"
import script from "./statisticsFilter.vue?vue&type=script&lang=js&"
export * from "./statisticsFilter.vue?vue&type=script&lang=js&"
import style0 from "./statisticsFilter.vue?vue&type=style&index=0&id=88183ef0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88183ef0",
  null
  
)

export default component.exports